import { isEmpty, isNumber, get } from 'lodash';
import { EnumValidatorType, IValidatorField } from './types';

export const validateRequired = <T extends object>(
  validation: IValidatorField,
  currentState: T
) : boolean => {
  if (validation.validations.required === false) {
    return true;
  }

  var value = get(currentState, validation.field);
  if (isNumber(value) && value <= 0) {
    return false;
  }
  if (!value) {
    return false;
  }

  if (Array.isArray(value)) {
    if (value.length < 1) {
       return false;
    }
  }

  return true;
};

export const validateRegex = <T extends object>(
  validation: IValidatorField,
  currentState: T
): { isValid: boolean; message: string | null } => {
  if (isEmpty(validation.validations.patterns)) {
    return { isValid: true, message: null };
  }
  const value = get(currentState, validation.field);
  const patterns = validation.validations.patterns || [];
  for (const pattern of patterns) {
    if (!pattern.value.test(value)) {
      return { isValid: false, message: pattern.message };
    }
  }
  return { isValid: true, message: null };
};

export const validateWhere = <T extends object>(
  validation: IValidatorField,
  currentState: T
) : boolean => {
  if (!validation.validations.where) return true;
  const {
    where: { fieldParent, value, required, patterns, validationType },
  } = validation.validations;
  
  const valueFiledtoParent = get(currentState, fieldParent);

  if(validationType === EnumValidatorType.Value && valueFiledtoParent !== value) return true;
  if(validationType === EnumValidatorType.Length && `${valueFiledtoParent}`.length < value) return true;
 
  const validationCustom: IValidatorField = {
    field: validation.field,
    validations: {
      required,
      patterns
    },
  };
  return validateRequired(validationCustom, currentState);
};

export const validateWhereRegex = <T extends object>(
  validation: IValidatorField,
  currentState: T
): { isValid: boolean; message: string | null } => {
  if (!validation.validations.where) {
    return { isValid: true, message: null };
  }

  const {
    where: { fieldParent, value, required, patterns, validationType },
  } = validation.validations;

  const valueFiledtoParent = get(currentState, fieldParent);
  if (validationType === EnumValidatorType.Value && valueFiledtoParent !== value) {
    return { isValid: true, message: null };
  }

  if (validationType === EnumValidatorType.Length && `${valueFiledtoParent}`.length < value) {
    return { isValid: true, message: null };
  }

  const validationCustom: IValidatorField = {
    field: validation.field,
    validations: {
      required,
      patterns,
    },
  };

  return validateRegex(validationCustom, currentState);
};
